import { render, staticRenderFns } from "./ui-tag.vue?vue&type=template&id=025a420c&lang=pug&"
import script from "./ui-tag.vue?vue&type=script&lang=js&"
export * from "./ui-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025a420c')) {
      api.createRecord('025a420c', component.options)
    } else {
      api.reload('025a420c', component.options)
    }
    module.hot.accept("./ui-tag.vue?vue&type=template&id=025a420c&lang=pug&", function () {
      api.rerender('025a420c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-pages/ui-tag.vue"
export default component.exports